// extracted by css-extract-rspack-plugin
export default {"loading":"elMvLnuxNGQsxZd3"};